import {notifications} from "@atttomyx/shared-constants";

export const PATH_DEEP_LINK = "/deep-link";

export const PLACEHOLDER_LANDSCAPE = "https://placehold.co/1408x768?text=Landscape+(16:9)";

export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyA9Dj9SL_KXAQw4DfB-66XmJvyAUytOMdo",
    authDomain: "cf-notifier.firebaseapp.com",
    projectId: "cf-notifier",
    storageBucket: "cf-notifier.appspot.com",
    messagingSenderId: "741330969895",
    appId: "1:741330969895:web:795f316c4aca845967f502",
    measurementId: "G-7YK8FMDCTM"
};

export const KEY_VERSION = "version";

export const OBSERVER_APP = "app";

export const MAX_FILE_SIZE_BYTES = 1024 * 1024 * 1024;  // 1 GB

export const TEMPLATE_ID_BUSINESS_PLAN = "business_plan";
export const TEMPLATE_ID_PITCH_DECK = "pitch_deck";

export const MESSAGE_AI = "Generated by AI. The more homework you submit, the better job it will be able to do.";

export const INVESTOR = "ROLE_INVESTOR";
export const INVENTOR = "ROLE_INVENTOR";

export const TYPE_ADMIN = "Admin";
export const TYPE_INVESTOR = "Investor";
export const TYPE_INVENTOR = "Inventor";

export const LABEL_ANY = "-any-";
export const LABEL_NONE = "-none-";

export const ANONYMOUS = "Anonymous";

export const TYPES = [
    TYPE_ADMIN,
    TYPE_INVESTOR,
    TYPE_INVENTOR,
];

export const STATUS_ACTIVE = "Active";
export const STATUS_DRAFT = "Draft";

export const STATUSES = [
    STATUS_ACTIVE,
    STATUS_DRAFT,
];

export const RANK_BRONZE = "Bronze";
export const RANK_SILVER = "Silver";
export const RANK_GOLD = "Gold";

export const RANKS = {
    [RANK_BRONZE]: "Bronze",
    [RANK_SILVER]: "Silver",
    [RANK_GOLD]: "Supreme",
};

export const RANKS_REQUIRED = {
    [RANK_BRONZE]: "Bronze",
    [RANK_SILVER]: "Silver",
    [RANK_GOLD]: "Supreme",
};

export const ANSWER_TYPE_STRING = "String";
export const ANSWER_TYPE_MULTILINE = "Multiline";
export const ANSWER_TYPE_INTEGER = "Integer";
export const ANSWER_TYPE_DOUBLE = "Double";
export const ANSWER_TYPE_BOOLEAN = "Boolean";
export const ANSWER_TYPE_DATE = "Date";
export const ANSWER_TYPE_SIGNATURE = "Signature";

export const ANSWER_TYPES = {
    [ANSWER_TYPE_STRING]: "String (e.g. 'name of invention')",
    [ANSWER_TYPE_MULTILINE]: "Paragraph (e.g. 'invention details')",
    [ANSWER_TYPE_INTEGER]: "Whole number (e.g. '7')",
    [ANSWER_TYPE_DOUBLE]: "Decimal number (e.g. '3.14')",
    [ANSWER_TYPE_BOOLEAN]: "Boolean (e.g. 'true')",
    [ANSWER_TYPE_DATE]: "Date (e.g. '2025-02-05')",
    [ANSWER_TYPE_SIGNATURE]: "Signature (drawn signature)",
};

export const YES_NO = [
    "Yes",
    "No",
];

export const VIEW_CARDS = "Cards";
export const VIEW_TABLE = "Table";

export const CSV_DELIMITER = ",";

export const CSV_FILENAME_CONTACTS = "contacts.csv";
export const CSV_FILENAME_USERS = "users.csv";

export const CSV_FIELD_FIRST_NAME = "first_name";
export const CSV_FIELD_LAST_NAME = "last_name";
export const CSV_FIELD_TYPE = "type";
export const CSV_FIELD_EMAIL = "email";
export const CSV_FIELD_PHONE = "phone";
export const CSV_FIELD_LEAD_SOURCE = "lead_source";
export const CSV_FIELD_LOGIN = "login";
export const CSV_FIELD_LISTENED = "listened";
export const CSV_FIELD_WATCHED = "watched";
export const CSV_FIELD_DOWNLOADED = "downloaded";
export const CSV_FIELD_UPLOADED = "uploaded";
export const CSV_FIELD_CREATED = "created";
export const CSV_FIELD_UPDATED = "updated";

export const CSV_HEADERS_CONTACTS = [
    {
        key: CSV_FIELD_FIRST_NAME,
        label: "First Name",
    },
    {
        key: CSV_FIELD_LAST_NAME,
        label: "Last Name",
    },
    {
        key: CSV_FIELD_EMAIL,
        label: "Email",
    },
    {
        key: CSV_FIELD_PHONE,
        label: "Phone",
    },
    {
        key: CSV_FIELD_LEAD_SOURCE,
        label: "Lead Source",
    },
    {
        key: CSV_FIELD_CREATED,
        label: "Created",
    },
    {
        key: CSV_FIELD_UPDATED,
        label: "Updated",
    },
];

export const CSV_HEADERS_USERS = [
    {
        key: CSV_FIELD_FIRST_NAME,
        label: "First Name",
    },
    {
        key: CSV_FIELD_LAST_NAME,
        label: "Last Name",
    },
    {
        key: CSV_FIELD_TYPE,
        label: "Type",
    },
    {
        key: CSV_FIELD_EMAIL,
        label: "Email",
    },
    {
        key: CSV_FIELD_PHONE,
        label: "Phone",
    },
    {
        key: CSV_FIELD_LISTENED,
        label: "Listened",
    },
    {
        key: CSV_FIELD_WATCHED,
        label: "Watched",
    },
    {
        key: CSV_FIELD_DOWNLOADED,
        label: "Downloaded",
    },
    {
        key: CSV_FIELD_UPLOADED,
        label: "Uploaded",
    },
    {
        key: CSV_FIELD_LOGIN,
        label: "Last Login",
    },
    {
        key: CSV_FIELD_CREATED,
        label: "Created",
    },
    {
        key: CSV_FIELD_UPDATED,
        label: "Updated",
    },
];

export const NOTIFICATION_TYPES = {
    account_joined: {
        admin: true,
        short: "New user",
        long: "A new user joins the account",
        delivery: notifications.DELIVERY_APP,
    },
    submission: {
        admin: true,
        short: "Homework Submission",
        long: "An inventor submits homework",
        delivery: notifications.DELIVERY_APP,
    },
    form_submitted: {
        admin: true,
        short: "Form Submission",
        long: "A contact submits a form",
        delivery: notifications.DELIVERY_APP,
    },
    asked_for_help: {
        admin: true,
        short: "Asked for help",
        long: "Someone asks for human help",
        delivery: notifications.DELIVERY_EMAIL,
    },
    contacted_inventor: {
        admin: true,
        short: "Investor reached out",
        long: "An investor reaches out to an inventor",
        delivery: notifications.DELIVERY_APP,
    },
    congratulations: {
        admin: false,
        short: "Congratulations",
        long: "A module is completed",
        delivery: notifications.DELIVERY_EMAIL,
    },
    file_uploaded: {
        short: "Uploaded file",
        long: "A file was uploaded",
        delivery: notifications.DELIVERY_APP,
    },
    file_downloaded: {
        short: "Downloaded file",
        long: "A file was downloaded",
        delivery: notifications.DELIVERY_APP,
    },
    file_deleted: {
        short: "Deleted file",
        long: "A file was deleted",
        delivery: notifications.DELIVERY_APP,
    },
};


export const TOPICS = {};

export const PAGE_LOGIN = "/login";
export const PAGE_RECOVERY = "/recovery";
export const PAGE_WELCOME = "/welcome";
export const PAGE_THANK_YOU = "/thank-you";

export const PAGE_SETTINGS = "/settings";
export const PAGE_PASSWORD = "/password";

export const PAGE_ABOUT = "/about";
export const PAGE_NOTIFICATIONS = "/notifications";

export const PAGE_FILES = "/files";

export const PAGE_USERS = "/users";
export const PAGE_USER = "/user";

export const PAGE_CONTACTS = "/contacts";
export const PAGE_CONTACT = "/contact";

export const PAGE_COURSES = "/courses";
export const PAGE_COURSE = "/course";

export const PAGE_QUESTIONNAIRES = "/questionnaires";
export const PAGE_QUESTIONNAIRE = "/questionnaire";

export const PAGE_TEMPLATES = "/templates";
export const PAGE_TEMPLATE = "/template";

export const PAGES_MAIN = [
    PAGE_USERS,
    PAGE_USER,
    PAGE_CONTACTS,
    PAGE_CONTACT,
    PAGE_COURSES,
    PAGE_COURSE,
    PAGE_QUESTIONNAIRES,
    PAGE_QUESTIONNAIRE,
    PAGE_TEMPLATES,
    PAGE_TEMPLATE,
    PAGE_FILES,
];

export const PAGES_MORE = [
    PAGE_NOTIFICATIONS,
    PAGE_SETTINGS,
    PAGE_PASSWORD,
    PAGE_ABOUT,
];

export const PRIVATE_PAGES_EXACT = [].concat(PAGES_MAIN).concat(PAGES_MORE);

export const PRIVATE_PAGES_STARTS_WITH = [
    PAGE_USER,
    PAGE_CONTACT,
];

export const PUBLIC_PAGES_EXACT = [
    PAGE_LOGIN,
    PAGE_RECOVERY,
    PAGE_THANK_YOU,
];

export const PUBLIC_PAGES_STARTS_WITH = [];
